import { Component, Input } from '@angular/core';
import { Table } from '../../../models/class/table.class';
import { Link } from '../../../models/class/link.class';
import { TableCardComponent } from '../table-card/table-card.component';
import { LinkCardComponent } from '../link-card/link-card.component';

@Component({
  selector: 'app-card-list',
  standalone: true,
  imports: [TableCardComponent, LinkCardComponent],
  templateUrl: './card-list.component.html',
  styleUrl: './card-list.component.scss',
})
export class CardListComponent {
  @Input()
  tableList!: Table[];

  @Input()
  linkList!: Link[];

  @Input()
  isEnglish!: boolean;
}
